import React, {Fragment, useEffect, useState} from 'react';
import {Route, Switch} from "react-router-dom";
import Meeting from "../components/meeting/Meeting";
import Question from "../components/question/Question";
import MeetingSearch from "../components/meeting/MeetingSearch";
import QuestionAnswers from "../components/question/QuestionAnswers";
import PendingManualApprove from "../components/meeting/PendingManualApprove";
import MultipleQuestions from "../components/question/MultipleQuestions";
import ZoomMeeting from "./meeting/ZoomMeeting";
import Header from "./Header";
import Footer from "./Footer";
import Loading from "./Loading";
import HTTPClient from "../HTTPClient";
import {Link, useHistory} from "react-router-dom";
import * as axios from "axios";
import Typography from "@material-ui/core/Typography";
import {getMessage} from "../util";
import MeetingTitle from "./meeting/MeetingTitle";
import Shares from "./meeting/Shares";
import Button from "@material-ui/core/Button";
import NotQuestionsFound from "./NotQuestionsFound";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Box from "@material-ui/core/Box";
import {Radio, RadioGroup} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import VideoConference from "./meeting/VideoConferece";


const loadMeeting = async (meeting_id, history) => {
    const meeting = await HTTPClient({
        method: "get",
        url:
            process.env.REACT_APP_API_URL +
            "/meetings/" + meeting_id
    });

    // check if open question
    const open_questions = meeting.data.questions.filter(q => {
        return (!q.url && q.state === 'open')
    });

    if (open_questions.length > 0) {
        history.push('/meeting/' + meeting.data.slug + '/questions');
    }
    return (meeting.data);
}

const Main = (props) => {

    const meeting_id = props.match.params.meeting_id;

    const [loading, setLoading] = useState(false);
    const [meeting, setMeeting] = useState(null);
    const [representative, setRepresentative] = useState(null);
    const [shares, setShares] = useState(null);
    const [hash, setHash] = useState("none");
    const [messages, setMessages] = useState(null);
    const [changeableWindow, setChangeableWindow] = useState(false);
    const [isFixed, setIsFixed] = useState(true);
    const [isRelated, setIsRelated] = useState(false);

    let history = useHistory();

    const resetLanguage = (event) => {
        localStorage.setItem('eholder-lang-'+meeting_id, event.target.value);
        messages.lang = event.target.value;
        setMessages({...messages});
    }

    const isFixedHandler = (inputIsFixed) => {
        setIsFixed(inputIsFixed);
    }

    const handleChange = (event) => {
        if (event.target.value === 'yes')
            setIsRelated(true);
        else
            setIsRelated(false);
    }

    const setRelated = async () => {
        try {
            await HTTPClient({
                method: "put",
                url:
                    process.env.REACT_APP_API_URL +
                    '/meetings/' + meeting_id + '/related/' + isRelated
            });

            const me = await HTTPClient({
                method: "get",
                url:
                    process.env.REACT_APP_API_URL +
                    "/meetings/" + meeting_id + "/me"
            });

            setRepresentative(me.data);
        } catch (error) {
            alert('No pudo responder relacionado');
        } finally {

        }
    }

    // effect to reload meeting when changed hash
    useEffect(() => {
        (async () => {
            try {
                const meeting = await loadMeeting(meeting_id, history);
                setMeeting(meeting);
                setChangeableWindow((meeting.zoom && meeting.zoom.changeable_window) ? meeting.zoom.changeable_window : false);
                // check if open question
                const open_questions = meeting.questions.filter(q => {
                    return (!q.url && q.state === 'open')
                });
                if (open_questions.length > 0) {
                    setIsFixed(false);
                }
                else {
                    setIsFixed(true);
                }
            } catch (error) {
                console.log("Main.js useEffect-hash loadMeeting error: ", error);
                switch (error.response.status) {
                    case 401:
                        window.location = '/login/' + meeting_id;
                        break;
                    case 403:
                        window.location = '/meeting/' + meeting_id + '/pending';
                        break;
                    default:
                        setLoading(false);
                        break;
                }
            }
        })()
    }, [hash]);

    // effect only once
    useEffect(() => {
        setLoading(true);
        (async () => {
            try {
                // load the meeting the first time
                const meeting = await loadMeeting(meeting_id, history);
                setChangeableWindow((meeting.zoom && meeting.zoom.changeable_window) ? meeting.zoom.changeable_window : false);

                const open_questions = meeting.questions.filter(q => {
                    return (!q.url && q.state === 'open')
                });
                if (open_questions.length > 0) {
                    setIsFixed(false);
                }
                else {
                    setIsFixed(true);
                }
                // load messages
                if (meeting.messages) {
                    const load_messages = await axios({
                        method: "get",
                        url: meeting.messages
                    });
                    const messages = load_messages.data;
                    const nav_lang = navigator.language.split('-')[0];

                    messages.lang = messages.languages.length > 1 ? (localStorage.getItem('eholder-lang-' + meeting_id) || nav_lang) : nav_lang;
                    setMessages(messages);
                }

                //load user
                const me = await HTTPClient({
                    method: "get",
                    url:
                        process.env.REACT_APP_API_URL +
                        "/meetings/" + meeting_id + "/me"
                });

                const shares = await HTTPClient({
                    method: "get",
                    url:
                        process.env.REACT_APP_API_URL +
                        "/meetings/" + meeting_id + "/me/shares"
                });

                setShares(shares.data);
                setMeeting(meeting);
                setRepresentative(me.data);
                setLoading(false);

                const intervalId = setInterval(() => {
                    (async () => {
                        try {
                            const got_hash = await HTTPClient({
                                method: "get",
                                url:
                                    process.env.REACT_APP_API_URL +
                                    "/meetings/" + meeting_id + "/hash"
                            });
                            setHash(got_hash.data);
                        } catch (error) {
                            console.log("Main.js useEffect-meetingId hash error: ", error);
                            switch (error.response.status) {
                                case 401:
                                    window.location = '/login/' + meeting_id;
                                    break;
                                case 403:
                                    window.location = '/meeting/' + meeting_id + '/pending';
                                    break;

                                default:
                                    setLoading(false);
                                    break;
                            }
                        }
                    })();
                }, 3000);
                return (() => {
                    clearInterval(intervalId);
                });
            } catch (error) {
                console.log("Main.js useEffect-meetingId loadMeeting error: ", error);
                switch (error.response.status) {
                    case 401:
                        window.location = '/login/' + meeting_id;
                        break;
                    case 403:
                        window.location = '/meeting/' + meeting_id + '/pending';
                        break;
                    default:
                        setLoading(false);
                        break;
                }
            }
        })();
    }, [meeting_id]);

    return (
        <Fragment>
            {loading ? (
                    <Loading/>
                ) : (
                    (meeting && representative && shares) ? (
                        <Fragment>
                            <Dialog
                                open={meeting.ask_related && (typeof representative.related === 'undefined')}
                                scroll="body"
                                onClose={props.handleClose}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">
                                    {getMessage(meeting.meeting_type, 'related_title', messages)}
                                </DialogTitle>

                                <DialogContent>
                                    <Box alignItems={"center"} justifyContent={"center"} display={"flex"}>
                                        <Typography>
                                            {getMessage(meeting.meeting_type, 'related', messages)}
                                        </Typography>
                                    </Box>
                                    <Box alignItems={"center"} justifyContent={"center"} display={"flex"}>
                                        <RadioGroup row
                                                    onChange={handleChange}
                                                    aria-label="relacionado"
                                                    name="relacionado"
                                        >
                                            <FormControlLabel value="yes" control={<Radio/>}
                                                              label={getMessage(meeting.meeting_type, 'yes', messages)}/>
                                            <FormControlLabel value="no" control={<Radio/>}
                                                              label={getMessage(meeting.meeting_type, 'no', messages)}/>
                                        </RadioGroup>
                                    </Box>
                                </DialogContent>
                                <DialogActions>
                                    <Button variant="outlined" autoFocus onClick={setRelated}>
                                        {getMessage(meeting.meeting_type, 'answer', messages)}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Header messages={messages} user={representative} logo={meeting.logo} meeting={meeting}
                                    shares={shares} resetLanguage={resetLanguage}/>
                            <hr/>
                            <MeetingTitle messages={messages} meeting={meeting}/>
                            <Shares messages={messages} meeting={meeting} user={representative}/>
                            { meeting.zoom && meeting.zoom.is_integrated &&
                                <ZoomMeeting
                                    meeting={meeting}
                                    changeableWindow={changeableWindow}
                                    isFixed={isFixed}
                                    onFixed={isFixedHandler}
                                />
                            }
                            {representative.observer &&
                            <Link to={"/meeting/" + meeting.slug + "/search"}>
                                <Button variant="contained" color={"default"}>
                                    {getMessage(meeting.meeting_type, 'watch_attendance', messages)}
                                </Button>
                            </Link>
                            }
                            {(representative && meeting) && meeting.state !== 'finished' && !(meeting.zoom && meeting.zoom.is_integrated) && (meeting.video_conf_url || representative.video_conf_url) && (
                                <VideoConference
                                    messages={messages}
                                    url={representative.video_conf_url?representative.video_conf_url:meeting.video_conf_url}
                                    meeting={meeting}
                                    username={representative.data.name}
                                />
                            )}

                            <Switch>
                                <Route path="/meeting/:meeting_id/question/:question_id/answers" exact component={QuestionAnswers}/>
                                <Route path="/meeting/:meeting_id/question/:question_id" exact component={Question}/>
                                <Route path="/meeting/:meeting_id/search" exact >
                                    <MeetingSearch
                                        meeting={meeting}
                                        messages={messages}
                                    />
                                </Route>
                                <Route path="/meeting/:meeting_id/pending" exact component={PendingManualApprove}/>
                                <Route path="/meeting/:meeting_id" exact>
                                    <Meeting
                                        meeting={meeting}
                                        representative={representative}
                                        messages={messages}
                                    />
                                </Route>
                                <Route path="/meeting/:meeting_id/questions" exact component={MultipleQuestions}/>
                                <Route component={NotQuestionsFound}/>
                            </Switch>
                            <Footer messages={messages} meeting={meeting}/>
                        </Fragment>
                    ) : (
                        <Typography variant="h5" component="h2">
                            {getMessage('default', 'meeting_not_found', null)}
                        </Typography>
                    )
                )
            }
        </Fragment>
    );
}

export default Main;
